// extracted by mini-css-extract-plugin
export default {"about_page":"AboutPage_about_page__ODdmX","schedule_section":"AboutPage_schedule_section__iHu4X","headingx":"AboutPage_headingx__HEL2+"};